"use strict";function i(i){return i&&"object"==typeof i&&"default"in i?i:{default:i}}var e=i(require("styled-components")).default.section`
    position: relative;
    margin: 73px ${({theme:i})=>i.spacing.large} 94px;

    @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
        margin: 87px ${({theme:i})=>i.spacing.large} 90px;
    }

    .inner {
        max-width: ${({theme:i})=>i.widths.small};
        margin: 0 auto;
        padding: 0;
        display: grid;
        grid-row-gap: 25px;
        width: 100%;
        box-sizing: border-box;

        @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
            max-width: ${({theme:i})=>i.widths.large};
            padding: 0;
            grid-row-gap: 31px;
        }
    }

    header {
        h2 {
            margin: 0;
        }
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-row-gap: 17px;

        @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
            grid-template-columns: repeat(3, 1fr);
            grid-row-gap: 22px;
            grid-column-gap: 24px;
        }
    }

    li {
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: 153px 1fr;
        grid-column-gap: 20px;
        box-shadow: ${({theme:i})=>i.shadows.mid};
        border-radius: 5px;
        overflow: hidden;

        picture {
            width: 100%;
            height: 100%;
            min-height: 100px;
            position: relative;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
        }

        p {
            font-weight: 700;
            margin: 27px 17px 27px 0;
        }
    }

    footer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 5px 0 0;

        @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
            padding: 15px 0 0;
        }

        .button {
            border-radius: 3px;
        }
    }
`;module.exports=e;
//# sourceMappingURL=styled.js.map
